module.exports = __webpack_public_path__ + "img/5.2254d3c2.jpg";